<template>
  <div class="row no-gutters checkout-container">
    <section class="col-lg-4 order-lg-last order-summary-container">
      <order-summary></order-summary>
    </section>

    <section class="col-lg-8 order-lg-first order-details-container">
      <div class="section-heading">
        <h3>Checkout</h3>
      </div>

      <div class="order-details" v-if="show_login">
        <div class="login-form">
          <label class="section-label">Login</label>
          <p>A customer already exists with your email address. Please login to complete this order.</p>
          <vue-login></vue-login>
        </div>
      </div>

      <div class="order-details" v-if="!show_login">
        <vue-address-details
          :details.sync="delivery.address"
          @updated:address="updateDeliveryAddress"
          type="Delivery"
          :getInstructions="true"
          errorMessage="Street Address is required. Please type the street address where you would like the SIM/s delivered."
        ></vue-address-details>

        <div class="payment-options">
          <!-- <label class="section-label">Payment Options</label>
          <div class="form-group">
            <vue-toggle
              :options="payment_details.payment_options"
              :default="payment_details.payment_options[0]"
              :selected.sync="payment_details.payment_option_type"
              class="row no-gutters"
            >
              <template slot-scope="{item}">
                <div class="col">
                  <button
                    type="button"
                    class="btn btn-default"
                    v-on:click="payment_details.payment_option_type = item.value"
                    v-bind:class="['btn btn-block', payment_details.payment_option_type == item.value ? 'btn-primary': 'btn-outline-primary']"
                  >{{ item.label }}</button>
                </div>
              </template>
            </vue-toggle>
          </div> -->

          <div
            class="payment-option-details form-group"
            v-if="payment_details.payment_option_type == 'debit_order'"
          >
            <vue-bank-details :details="payment_details.bank_details"></vue-bank-details>
          </div>

          <label class="section-label">Promotions</label>
          <div class="form-group">
            <input
              type="text"
              name="promo_code"
              v-model="promo_code"
              class="form-control"
              placeholder="Promo Code"
            />
          </div>
        </div>
        <div class="user-details" v-if="!isAuthenticated && cart.sims.length > 0">
            <div class="managae-profile">
              <h4>Manage Profile details</h4>
              <p>Please capture username and password below to manage profile.</p>
          </div>  
          <div class="row">
            <div class="col-lg-6 form-group">
              <label class="section-label">Username</label>
              <div class="form-group">
                <input
                  type="text"
                  name="email"
                  autocomplete="username"
                  class="form-control"
                  placeholder="Enter Email"
                  v-model="username"
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-6 form-group">
              <label class="section-label">Password</label>
              <div class="form-group">
                <input
                  v-validate="'required'"
                  type="password"
                  name="password"
                  autocomplete="current-password"
                  class="form-control"
                  placeholder="password"
                  v-model="password"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="check-boxes">
          <input
            class="check-box"
            type="checkbox"
            id="keep-in-touch"
            name="keep-in-touch"
            v-model="keep_in_touch"            
          />
          <label for="keep-in-touch">Keep in touch with us for the latest specials &amp; info.</label>
          <div
            class="help text-danger"
            v-show="errors.has('keep-in-touch')"
          >{{ errors.first('keep-in-touch') }}</div>
        </div>
        <div class="check-boxes" v-if="display_fup">
          <input
            class="check-box"
            type="checkbox"
            id="accepted-fup"
            name="accepted-fup"
            v-model="accepted_fup"
            data-vv-as="Accept FUP Terms"
            v-validate="'required'"
          />
          <label for="accepted-fup">
            I accept the
            <a href="/compliance/fup-policy">Unlimited Talk Fair Use Policy</a>
          </label>
          <div
            class="help text-danger"
            v-show="errors.has('accepted-fup')"
          >{{ errors.first('accepted-fup') }}</div>
        </div>
        <div class="check-boxes">
          <input
            class="check-box"
            type="checkbox"
            id="accepted-terms"
            name="accepted-terms"
            v-model="accepted_terms"
            data-vv-as="Accept Terms"
            v-validate="'required'"
          />
          <label for="accepted-terms">
            I accept the
            <a href="/compliance/terms">Terms &amp; Conditions</a>
          </label>
          <div
            class="help text-danger"
            v-show="errors.has('accepted-terms')"
          >{{ errors.first('accepted-terms') }}</div>
        </div>

        <div class="complete-error" v-if="has_error">{{ message }}</div>

        <div class="page-controls checkout-controls mt-5">
          <div class="row no-gutters">
            <vue-recaptcha sitekey="6LcLBq0UAAAAAKt1NkshjaqFaq6EHJQXlaoigXxK">
              <button
                type="button"
                class="col btn btn-primary next"
                v-on:click="validateCustomer"
                :disabled="show_login || cart.sims.length < 1 || processing"
              >
                {{ payment_details.payment_option_type !== 'credit_card' ? "Submit Order" : "Pay Now" }}
                <i
                  class="fa fa-chevron-right"
                  aria-hidden="true"
                ></i>
              </button>
            </vue-recaptcha>
            <button
              type="button"
              class="d-block d-sm-none mt-3 col-12 btn btn-block btn-default back"
              v-on:click="backStep"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import store from "@/store";
import { USER_LOGIN } from "@/store/actions.type";

import EventBus from "@/components/shared/event-bus";
import OrderService from "@/services/order.service.js";
import CustomerService from "@/services/customer.service.js";

import DeliveryModel from "@/models/delivery.model";
import PaymentDetailsModel from "@/models/payment-details.model";
import AddressModel from "@/models/address.model";

import VueLogin from "@/components/elements/vue-login";
import VueAddressDetails from "@/components/elements/vue-address-details";
import OrderSummary from "./order-summary.vue";
import VueBankDetails from "@/components/elements/vue-bank-details.vue";

import { mapGetters } from "vuex";

import VueRecaptcha from "vue-recaptcha";

export default {
  name: "order-details",
  components: {
    "order-summary": OrderSummary,
    "vue-bank-details": VueBankDetails,
    "vue-address-details": VueAddressDetails,
    "vue-login": VueLogin,
    VueRecaptcha
  },
  computed: {
    ...mapGetters(["currentStep", "cart", "isAuthenticated", "currentUser"]),
    displayBack() {
      return this.currentStep > 0;
    }
  },
  watch: {
    isAuthenticated(value, oldValue) {
      var self = this;

      //Set address if user logs in
      if (value && self.currentUser) {
        self.delivery.address = new AddressModel(self.currentUser.address);
        self.show_login = false;
      }

      //Reset address if user logs out.
      if (!value && oldValue) {
        self.clearAddressForm();
      }
    }
  },
  mounted() {
    var self = this;
    self.$scrollTo("body");
    self.setDisplayFup();
    if (self.isAuthenticated && self.currentUser) {
      self.delivery.address = new AddressModel(self.currentUser.address);
    } else {
      var emails = [];
      self.cart.sims.forEach(sim => {
        emails.push(sim.subscriber.email_address);
      });
      self.validateEmailExists(emails);
      if (self.cart.sims.length > 0)
        self.username = self.cart.sims[0].subscriber.email_address;
    }
  },
  data: function() {
    return {
      delivery: new DeliveryModel(),
      show_login: false,
      processing: false,
      has_error: false,
      promo_code: "",
      message: "",
      payment_details: new PaymentDetailsModel(),
      banks: [],
      accepted_terms: false,
      username: "",
      password: false,
      keep_in_touch: false,
      accepted_fup: false,
      display_fup: false
    };
  },
  methods: {
    setDisplayFup() {
      var self = this;
      self.cart.sims.forEach(sim => {
        var unlimited = ((sim.deal != null && sim.deal.fup) || (sim.mins != null && sim.mins.fup));
        if (!self.display_fup && unlimited) {
          self.display_fup = true;
        }
      });
    },
    validateCustomer() {
      var self = this;

      var customerSim = self.cart.sims[0].subscriber
      CustomerService.isBlackListed(customerSim.email_address ,customerSim.mobile_number ,customerSim.id_number).then(({ data }) => {
        self.is_loading = false;
        self.$log.debug("validateCustomer FUP", data);
        if(!data.success)  {
            self.has_error = true;
            self.message = "Invalid request. Please contact support.";
        } else {
          if(data.success && data.data) {
            self.has_error = true;
            self.message = "Unfortunately this customer is blacklisted. Please contact support.";
          } else {
            //process payment
            self.payNow();
          }
        }
      })
      .catch(({ response }) => {
        self.is_loading = false;
        self.$log.error(response);
        self.error_message =
          "Unfortunately we cannot complete this request. Please contact support.";
      });
        
    },
    payNow() {
      var self = this;      
      self.has_error = false;
      self.processing = true;
      self.$log.debug("Address", self.delivery.address);
      self.$log.debug(self.delivery.address.is_valid);
      if (!self.delivery.address.isValidAddress()) {
        self.processing = true;
        return false;
      }
      if (!self.payment_details.validatePaymentDetails()) {
        self.has_error = true;
        self.processing = false;
        self.message = "All banking details are required.";
        return false;
      }
      self.$validator.validateAll().then(success => {
        self.$log.debug("PayNow Validation Response", success);
        EventBus.$emit("global_loading", {
          is_loading: true,
          loading_message: "Processing Request..."
        });

        self.delivery.is_required = self.cart.delivery.is_required;
        self.$log.debug(
          "Payment request",
          self.payment_details.payment_option_type
        );

        //Payment Request. Login & Redirect to payment on success.
        OrderService.sim(
          self.delivery,
          self.payment_details,
          self.promo_code,
          self.cart.sims,
          self.currentUser,
          self.password
        )
          .then(function(response) {
            self.$log.debug("Payment request response", response);
            var r = response.data;
            if (r.success) {
              self.$log.debug("Payment Request", r);

              var route_info = {
                name: "payment",
                params: {
                  payment_type: self.payment_details.payment_option_type
                }
              };

              if (!self.isAuthenticated && self.password) {
                var credentials = {
                  username: self.username,
                  password: self.password
                };
                self.$log.debug("USER IS LOGGING IN");
                store.dispatch(USER_LOGIN, credentials);
              }

              if (self.payment_details.payment_option_type == "credit_card") {
                route_info.params.CHECKSUM = r.data.CHECKSUM;
                route_info.params.PAY_REQUEST_ID = r.data.PAY_REQUEST_ID;
                self.$router.push(route_info);
              } else {
                route_info.params.orders = r.data;
                self.$router.push(route_info);
              }
            } else {
              EventBus.$emit("global_loading", { is_loading: false });
            }
          })
          .catch(function(error) {
            EventBus.$emit("global_loading", { is_loading: false });
            self.has_error = true;
            self.message =
              "We could not process your payment. Please contact support for further assistance.";
            if (
              !self.isEmpty(error.response) &&
              !self.isEmpty(error.response.data)
            ) {
              self.message = error.response.data.message;
            }
            self.$log.error("Error requesting payment", error);
          });
        return success;
      });
    },
    updateDeliveryAddress(address) {
      var self = this;
      self.delivery.address = address;
    },
    addAnother() {
      var self = this;
      self.$router.push({ name: "build-your-deal" });
    },
    backStep() {
      var self = this;
      self.$router.push({ name: "build-your-deal" });
    },
    isEmpty(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    },
    validateEmailExists(emails) {
      var self = this;
      CustomerService.exists(emails).then(function({ data }) {
        var response = data;
        self.$log.debug("Customer exists response", response);
        if (response.success && response.data) {
          self.$log.debug("Customer exists");
          self.show_login = true;
        }
      });
    },
    userAuthenticated(state) {
      self.show_login = !(state && self.show_login);
    }
  }
};
</script>